export class TextMapping {

    public modelIndex: number
    public textIndex: number
    public mappings: Map<number, number>

    constructor(private blockSeparatorLength: number) {
        this.modelIndex = -1
        this.textIndex = 0
        this.mappings =new Map<number, number>()
    }

    public mapText(text: string) {
        const chars = [...text]

        chars.forEach(_c => {
            this.mappings.set(this.textIndex, this.modelIndex)
            this.textIndex++
            this.modelIndex++
        })
    }

    separateIfNeeded() {
        if (this.modelIndex > 0) {
            this.separate()
        }
    }

    separate() {
        this.textIndex += this.blockSeparatorLength
    }

    increaseModel(nodeSize: number) {
        this.modelIndex += nodeSize
    }

    increaseSerializedText(textLength: number, nodeSize: number) {
        this.textIndex +=  textLength
        this.modelIndex += nodeSize
    }

    startBlock() {
        // Match TipTap's getTextBetween behavior: add separator for every block
        // when position > 0 (i.e., not the first block in the document)
        // TipTap: if (node.isBlock && pos > from) { text += blockSeparator }
        if (this.modelIndex > 0) {
            this.separate()
        }
        this.modelIndex++
    }

    endBlock() {
        this.modelIndex++
    }
}

